import { i as e, r as t, t as n } from "./settings-DmfZujXC.js";
//#region src/lib/helpers.ts
function r() {
	return window.nosto !== void 0;
}
function i() {
	return window.nosto;
}
//#endregion
//#region src/utils/url.ts
var a = {
	production: "https://connect.nosto.com/",
	staging: "https://connect.staging.nosto.com/",
	local: "https://connect.nosto.com/"
};
function o(e) {
	return a[e ?? "production"];
}
//#endregion
//#region src/lib/init.ts
function s({ merchantId: e, env: t, options: n, shopifyInternational: r, scriptLoader: i }) {
	let a = document.querySelector("script[nosto-language], script[nosto-market-id]"), s = String(r?.marketId || ""), c = r?.language || "", u = a?.getAttribute("nosto-language") !== c || a?.getAttribute("nosto-market-id") !== s;
	if (!a || u) {
		let r = document.querySelector("#nosto-sandbox");
		a?.parentNode?.removeChild(a), r?.parentNode?.removeChild(r);
		let u = new URL("/script/shopify/market/nosto.js", o(t));
		u.searchParams.append("merchant", e), u.searchParams.append("market", s), u.searchParams.append("locale", c.toLowerCase());
		let d = {
			...n?.attributes,
			"nosto-language": c,
			"nosto-market-id": s
		};
		return (i ?? l)(u.toString(), {
			...n,
			attributes: d
		});
	}
	return Promise.resolve();
}
function c(e) {
	if (e.shopifyInternational) return s(e);
	let { merchantId: t, env: n, options: r, scriptLoader: i } = e;
	return (i ?? l)(new URL(`/include/${t}`, o(n)).toString(), r);
}
function l(e, t) {
	return new Promise((n, r) => {
		let i = document.createElement("script");
		i.src = e, i.async = !0, i.type = "text/javascript", i.onload = () => n(), i.onerror = () => r(), Object.entries(t?.attributes ?? {}).forEach(([e, t]) => i.setAttribute(e, t)), t?.position === "head" ? document.head.appendChild(i) : document.body.appendChild(i);
	});
}
//#endregion
//#region src/lib/addSkuToCart.ts
async function u(e, t, n) {
	if (!window.Nosto?.addSkuToCart) throw Error("Nosto addSkuToCart function is not available");
	await window.Nosto.addSkuToCart(e, t, n);
}
//#endregion
//#region src/index.ts
typeof window < "u" && e();
//#endregion
export { u as addSkuToCart, i as getNostoWindow, n as getSettings, c as init, e as initNostoStub, r as isNostoLoaded, t as nostojs };
